import isString from 'lodash/isString';

export const transformJSONStringToObject = (value: string | unknown) => {
	try {
		if (isString(value) && JSON.parse(value)) {
			return JSON.parse(value);
		}
	} catch (e) {
		return value;
	}
	return value;
};
